import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewProvincia = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'provincia',
        name: 'Provincia',
        component: ViewProvincia,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router